import { AssignTestKitToPatientPayload, UserType } from "@/common/types";
import AutoComplete from "@/components/autocomplete";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import useDebounce from "@/hooks/use-debounce";
import { assignTestKitToPatient } from "@/redux/actions/testKitActions";
import { getAllPatients } from "@/redux/actions/usersActions";
import { RootState } from "@/redux/reducers";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

const AssignToPatient = () => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [formState, setFormState] = useState({
    patient: null,
  });
  const [error, setError] = useState<string>("");

  const [searchTerm, setSearchTerm] = useState<string>("");
  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  const { patients } = useSelector((state: RootState) => state.users);

  const params = useParams();
  const dispatch: any = useDispatch();

  const handleSelect = (key: string, value: string) => {
    setFormState((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const validateInput = () => {
    let errorMessage = "";
    if (!formState.patient || formState.patient === "") {
      errorMessage = "Patient is required";
    } else {
      errorMessage = "";
    }
    setError(errorMessage);
    return errorMessage;
  };

  const handleSubmit = () => {
    const errorMessage = validateInput();
    if (!errorMessage) {
      const payload: AssignTestKitToPatientPayload = {
        patient: formState.patient,
      };
      dispatch(
        assignTestKitToPatient(Number(params.id), payload, () =>
          setIsOpen(false)
        )
      );
    }
  };

  useEffect(() => {
    if (isOpen) dispatch(getAllPatients(debouncedSearchTerm));
  }, [isOpen, debouncedSearchTerm]);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button variant="secondary">Assign to Patient</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Assign to Patient</DialogTitle>
          <DialogDescription>
            Assign the test kit to a patient.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          {error && (
            <div className="grid grid-cols-4 items-center gap-4">
              <div className="col-span-4">
                <p className="text-red-500 text-sm">{error}</p>
              </div>
            </div>
          )}
          <div className="grid grid-cols-4 items-center gap-4">
            <div className="col-span-4">
              <AutoComplete
                placeHolder="patient"
                options={patients as UserType[]}
                labelKey="name"
                onSelect={(option) => handleSelect("patient", option?.id)}
                onChange={(search) => setSearchTerm(search)}
                listCount={5}
              />
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button type="submit" onClick={() => handleSubmit()}>
            Assign
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AssignToPatient;
